import { FunctionComponent, useState } from 'react'
import { Box, TextField } from '@material-ui/core'
import { ReactComponent as MailArrow } from 'icons/sent-arrow.svg'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import {useNotification} from 'hooks/use-notification/useNotification'
import validator from 'validator'
import { Button } from 'common/atoms/Button/Button'

//@ts-ignore
import { useTheme } from 'styled-components'

interface EmailInviteProps {
  onSubmit: Function
  ticketId?: string
  setShowShareMemberPass?: Function
}
export const EmailInvite: FunctionComponent<EmailInviteProps> = ({ onSubmit, ticketId, setShowShareMemberPass}) => {
  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  const [email, setEmail] = useState('')
  const {notify} = useNotification()

  const validateEmail = () =>{
    if(validator.isEmail(email)){
      return true
    } 
    notify("error", "Invalid Email Address")
    return false
  }

  return (
    <Box display="flex" flexDirection="column" width="100%" padding="1em">
      <Box display="flex" marginLeft={isDevice ? '1em' : '0'}>
        <Box width={isDevice ? '75%' : '100%'}>
          <TextField
            value={email}
            autoComplete= 'none'
            onChange={e => setEmail(e.target.value)}
            variant="outlined"
            placeholder="Contacts Email Address"
            fullWidth
            name="email"
            type="email"
          />
        </Box>
        <Box bgcolor={theme.colors.supplementary} borderRadius="8%" textAlign="center" margin="0 0 0 1em">
          <Button
            design='tertiary'
            small
            startIcon={<MailArrow fill={theme.colors.primary} />}
            onClick={() => {
              if (validateEmail()) {
                if (ticketId && setShowShareMemberPass){
                  onSubmit(email, ticketId)
                  setShowShareMemberPass(false)
                  }
                  else {
                  onSubmit([email])
                  setEmail('')
                  }
              }
            
            }}
          >
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
